

export default {
  components: {
    'id-structured-data-lazy-breadcrumbs': () => import('~/components/structured-data/lazy/Breadcrumbs.vue')
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    diagram: {
      type: Object,
      required: true
    },
    slide: {
      type: Object,
      required: false,
      default: undefined
    }
  },
  computed: {
    diagramUrl () {
      if (this.slide) {
        return `/diagrams/${this.diagram.url}#slide_${this.slide.number}`
      } else {
        return `/diagrams/${this.diagram.url}/`
      }
    },
    crumbs () {
      const crumbs = [
        {
          url: '/',
          title: 'infoDiagram'
        }
      ]
      if (this.categories) {
        this.categories.forEach((category) => {
          crumbs.push({
            url: `/category/${category.url}/`,
            title: category.name
          })
        })
      }
      crumbs.push({
        url: this.diagramUrl,
        title: this.diagram.title
      })
      if (this.slide) {
        crumbs.push({
          url: `/slides/${this.slide.url_title}/`,
          title: this.slide.title
        })
      }
      return crumbs
    }
  }
}
